import React from 'react'
import PropTypes from 'prop-types'

/**
 * Arrow icon component.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.className] - Additional CSS class names.
 * @returns {JSX.Element} The rendered ArrowIcon component.
 */
export const ArrowIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 15L12.5 10L7.5 5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

ArrowIcon.propTypes = {
  className: PropTypes.string,
}
